import AudioMessage from './AudioMessage';

export default AudioMessage;
